import { createApi } from '@reduxjs/toolkit/query/react';
import type { LoginResponse } from './response_models/auth/LoginResponse';
import type { LoginRequest } from './request_models/auth/LoginRequest';
import { baseQueryWithReauth } from './api';

interface GoogleSigninRequest {
  access_token: string;
}
export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQueryWithReauth,
  endpoints: builder => ({
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: body => ({
        url: `auth/login/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: () => [{ type: 'vehicles' as never }],
    }),
    googlesignin: builder.mutation<LoginResponse, GoogleSigninRequest>({
      query: body => ({
        url: `auth/google/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: () => [{ type: 'vehicles' as never }],
    }),
    logout: builder.mutation<void, string | null>({
      query: refreshToken => ({
        url: `auth/logout/`,
        method: 'POST',
        body: { refresh_token: refreshToken },
      }),
    }),
    forgotPassword: builder.mutation<void, string>({
      query: email => ({
        url: `auth/password-reset/`,
        method: 'POST',
        body: { email },
      }),
    }),
    resetPassword: builder.mutation<void, { uidb64: string; token: string; password: string }>({
      query: ({ uidb64, token, password }) => ({
        url: `auth/password-reset-confirm/`,
        method: 'POST',
        body: { uidb64, token, password },
      }),
    }),
    verifyEmail: builder.mutation<void, string>({
      query: email => ({
        url: `auth//send-account-verification-email/`,
        method: 'POST',
        body: { email },
      }),
    }),
    verifyEmailConfirm: builder.mutation<void, { uidb64: string; token: string }>({
      query: ({ uidb64, token }) => ({
        url: `auth/verify-email/`,
        method: 'POST',
        body: { uidb64, token },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useGooglesigninMutation,
  useVerifyEmailMutation,
  useVerifyEmailConfirmMutation,
} = authApi;
